import React from 'react';
import Head from 'next/head';

const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo/logo.webp`;

interface ISeoHeadProps {
  title: string;
  description: string;
  canonicalURL: string;
  schema: object;
  image?: string;
  type?: 'website' | 'article';
  publishedTime?: string | null;
  modifiedTime?: string | null;
}

export const serializeSchema = (schema: object) =>
  JSON.stringify(schema)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');

const SeoHead: React.FC<ISeoHeadProps> = ({
  title,
  description,
  canonicalURL,
  schema,
  image = DEFAULT_OG_IMAGE,
  type = 'website',
  publishedTime,
  modifiedTime,
}) => (
  <Head>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={canonicalURL} />
    <link rel="alternate" hrefLang="en" href={canonicalURL} />
    <link rel="alternate" hrefLang="x-default" href={canonicalURL} />

    <meta property="og:site_name" content="Quran Pro" />
    <meta property="og:type" content={type} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />
    <meta property="og:url" content={canonicalURL} />
    {type === 'article' && publishedTime && (
      <meta property="article:published_time" content={publishedTime} />
    )}
    {type === 'article' && modifiedTime && (
      <meta property="article:modified_time" content={modifiedTime} />
    )}

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />

    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: serializeSchema(schema) }}
    />
  </Head>
);

export default SeoHead;
